import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle, CFormInput, CFormLabel, CFormTextarea } from '@coreui/react'
import { useEffect, useState } from 'react'
import Graytextarea from '../../components/Graytextarea'
import SaveExtra from '../../../src/services/general/saveExtraData.api'
import PatientOrdersCRUD from '../../../src/services/general/patientOrders.api'
import { Circle, Plus } from 'lucide-react'
import AddOrders from './AddOrders'
import Editor, { Toolbar } from 'react-simple-wysiwyg'
import BulletTextArea from '../../components/BulletTextArea'

const PatientTreatmentsPlans = ({
  noteStructureRef,
  isAllotedToProvider = false,
  saveTreatsShell,
  patientID,
  showDataIfNoteIsFollowUp,
  allTreamentStatements,
  setAllTreatmentStatements,
  contentEditable = false,
  isTextInput,
  showTreatmentAsAccordion,
  diagnosisName,
  patientTreatments,
  medicationList,
  masterMedications,
  allLabs,
  noteID,
}) => {
  const [allData, setAllData] = useState([])
  const [planFormat, setPlanFormat] = useState('')
  const [lab, setLab] = useState('')
  const [planSuggestion, setPlanSuggestion] = useState('')
  const [templateStatement, setTemplateStatement] = useState('')
  const [misc, setMisc] = useState('')
  const [testMisc, setTestMisc] = useState('')
  const [orderModalVisible, setOrderModalVisible] = useState(false)
  const [orders, setOrders] = useState([])
  const [freeType, setFreeType] = useState('')
  const [showEditHtml, setShowEditHtml] = useState(false)
  const [tempHtmlContent, setTempHtmlContent] = useState('')

  const [showMedHtml, setShowMedHtml] = useState(false)
  const [tempMedHtmlContent, setTempMedHtmlContent] = useState('')

  const [showPlanSuggestionHtml, setShowPlanSuggestionHtml] = useState(false)
  const [tempPlanSuggestionHtml, setTempPlanSuggestionHtml] = useState('')

  const fetchOrders = async () => {
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)

      data = JSON.parse(data?.d).Data || []

      const parsedOrders = data
        ?.map((order) => ({
          // ...order,
          date: order.date,
          medication: JSON.parse(order.medication),
        }))
        .filter((item) => item.medication?.diagnosis === diagnosisName)

      setOrders(parsedOrders)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  useEffect(() => {
    fetchOrders()
  }, [])

  useEffect(() => {
    const matched = allTreamentStatements?.length > 0 && allTreamentStatements?.find((item) => item.Data?.diagnosis?.label === diagnosisName)

    if (matched) {
      const suggestionNames = matched.Data.accordions.flatMap((accordion) => accordion?.suggestions?.suggestionName || []).map((s) => s.name)
      const joinedStatements = suggestionNames?.join('\n')
      setTemplateStatement(joinedStatements)

      if (joinedStatements) {
        noteStructureRef.current = {
          ...noteStructureRef.current,
          plans: {
            ...noteStructureRef.current.plans,
            [diagnosisName]: {
              // ...noteStructureRef.current?.plans[diagnosisName],
              ...(noteStructureRef.current.plans?.[diagnosisName] || {}),
              templateStatement: joinedStatements,
            },
          },
        }
      }
    }
  }, [allTreamentStatements])

  useEffect(() => {
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans?.[diagnosisName],
          templateStatement: noteStructureRef.current.plans?.[diagnosisName]?.templateStatement || '',
          medsDetails: noteStructureRef.current.plans?.[diagnosisName]?.medsDetails || [],
          labRemark: noteStructureRef.current.plans?.[diagnosisName]?.labRemark || '',
          freeType: noteStructureRef.current.plans?.[diagnosisName]?.freeType || '',
          orders: noteStructureRef.current.plans?.[diagnosisName]?.orders || [],
          planSuggestion: noteStructureRef.current.plans?.[diagnosisName]?.planSuggestion || '',
        },
      },
    }
  }, [templateStatement, lab, misc, planSuggestion, orders])

  const handleMedicationAdd = () => {
    let lastLabsRemarks = []
    let newAssessment = ''

    if (allLabs?.length > 0) {
      const lastLab = allLabs[allLabs.length - 1]

      const lastLabArrOfLabs = lastLab?.data || []

      let allMatchingLab = lastLabArrOfLabs.filter((item) => {
        const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
        return diagnosisLab.some((diagn) => diagn.includes(diagnosisName))
      })

      lastLabsRemarks = allMatchingLab.map((item) => item.planRemark).filter((item) => item !== '')
    }

    if (lastLabsRemarks.length > 0) {
      if (newAssessment !== '') {
        newAssessment += '\n\n' // Add a separator between previous and new content
      }
      newAssessment += lastLabsRemarks.join('\n')
      setLab(newAssessment)
      // setMisc(newAssessment)
      noteStructureRef.current = {
        ...noteStructureRef.current,
        plans: {
          ...noteStructureRef.current.plans,
          [diagnosisName]: {
            ...noteStructureRef.current?.plans?.[diagnosisName],
            labRemark: newAssessment,
          },
        },
      }
    }

    if (medicationList && medicationList.length > 0 && masterMedications && masterMedications.length > 0) {
      const lastMedicationAdded = medicationList[0] || []
      // const lastMedicationAdded = medicationList[0];

      if (!lastMedicationAdded) return
      const { data } = lastMedicationAdded

      let dataForParticularMeds = []

      for (const medsInBundle of data) {
        // if (medsInBundle?.Diagnosis?.length > 0) {
        //     const findMasterHavingMedsName = medsInBundle?.Diagnosis.map((item) => item.label).includes(diagnosisName)
        //     if (findMasterHavingMedsName) {
        //         dataForParticularMeds.push({
        //             editedMed: `${medsInBundle?.name} ${medsInBundle?.dosage} ${medsInBundle?.route} ${medsInBundle?.frequency}`,
        //         });
        //     }
        // }

        const findMasterHavingMedsName = masterMedications.find((item) => item?.Data?.name === medsInBundle?.name)
        // const findMasterHavingMedsName = masterMedications.find(item => (item.Data.name === medsInBundle.name || item.Data.name === medsInBundle?.Diagnosis?.any(dia => dia.label === medsInBundle.name)));
        if (findMasterHavingMedsName) {
          if (findMasterHavingMedsName.Data?.diagnoses.includes(diagnosisName)) {
            dataForParticularMeds.push({
              // ...findMasterHavingMedsName?.Data, medDetail: medsInBundle,
              id: findMasterHavingMedsName.Data?.id,
              name: findMasterHavingMedsName.Data?.name,
              sideEffect: findMasterHavingMedsName.Data?.sideEffect,
              mechanismOfAction: findMasterHavingMedsName.Data?.mechanismOfAction,
              alerts: findMasterHavingMedsName.Data?.alerts,
              therapeuticLevels: findMasterHavingMedsName.Data?.therapeuticLevels,
              standingTemplateName: findMasterHavingMedsName.Data?.standingTemplateName,
              extraStandings: findMasterHavingMedsName.Data?.standingTemplateName,
              frequency: medsInBundle?.frequency,
              dosage: medsInBundle?.dosage,
              // dosage: findMasterHavingMedsName.Data?.dosage,
              route: findMasterHavingMedsName.Data?.method,
              editedMed: `${findMasterHavingMedsName.Data?.name} ${medsInBundle?.dosage} ${findMasterHavingMedsName.Data?.method} ${medsInBundle?.frequency}`,
            })
          }
        }
      }
      const addCustomAsWell = data
        .filter((item) => item.Diagnosis && item.Diagnosis.some((dia) => dia.label === diagnosisName) && !masterMedications.find((med) => med.Data.name === item.name))
        ?.map((item) => ({
          id: item?.id,
          name: item?.name,
          sideEffect: '',
          mechanismOfAction: '',
          alerts: '',
          therapeuticLevels: {},
          standingTemplateName: '',
          extraStandings: '',
          frequency: item?.frequency,
          dosage: item?.dosage,
          route: item?.route,
          editedMed: `${item?.name} ${item?.dosage || ''} ${item?.route} ${item?.frequency}`,
        }))

      dataForParticularMeds = [...dataForParticularMeds, ...addCustomAsWell]

      const formattedMedicationDetails = dataForParticularMeds
        .map((item) => {
          return `${item?.name} - ${item?.dosage} - ${item?.medDetail?.frequency} \n${item?.standingTemplateName}`
        })
        .join('\n\n')

      const formattedMedicationDetailsInFormattedRed = dataForParticularMeds
        .map((item) => {
          // return `${item?.name} - <span>${item?.dosage}</span> - <span class="med-frequency" >${item?.frequency}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span></span>`;
          // return ` <span>${item?.editedMed}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.sideEffect}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.mechanismOfAction}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.alerts}</span> <br/> <span class="standing-template" style="color: #f9b115;">${item?.therapeuticLevels?.min} - ${item?.therapeuticLevels?.max}</span>`;
          return ` <span style="color: #000000d9;">${item?.editedMed}</span> <br/> `
        })
        .join('<br/><br/>')

      setAllData(dataForParticularMeds)

      setPlanFormat(formattedMedicationDetailsInFormattedRed)
      // const combinedPlans = `${standingMedicationTemplate}${formattedMedicationDetails ? `\n\n${formattedMedicationDetails}` : ""}`;

      // setPlans(combinedPlans);
      noteStructureRef.current = {
        ...noteStructureRef.current,
        plans: {
          ...noteStructureRef.current.plans,
          [diagnosisName]: {
            ...(noteStructureRef.current.plans?.[diagnosisName] || {}),
            medsDetails: dataForParticularMeds,
          },
        },
      }

      // noteStructureRef.current = {
      //     ...noteStructureRef.current,
      //     medicationDetails: {
      //         ...noteStructureRef.current.medicationDetails,
      //         [diagnosisName]: dataForParticularMeds.length > 0 ? dataForParticularMeds : []
      //     }
      // };
    }
  }

  useEffect(() => {
    let lastLabsRemarks = []
    let newAssessment = ''

    if (patientTreatments && patientTreatments.length > 0) {
      let treatmentDetails = patientTreatments[noteID || 0]

      if (!treatmentDetails) {
        treatmentDetails = patientTreatments[0]
      }

      const { data } = treatmentDetails

      let miscing = noteStructureRef?.current?.plans?.[diagnosisName]?.freeType || ''
      let freeType = noteStructureRef?.current?.plans?.[diagnosisName]?.freeType || ''
      let planSuggestion = noteStructureRef.current?.plans?.[diagnosisName]?.planSuggestion ?? noteStructureRef?.current?.plans?.[diagnosisName]?.planSuggestion ?? '' // or default string/object
      if (planSuggestion !== undefined) {
        console.log('Plan suggestion:', planSuggestion)
      } else {
        console.warn('Plan suggestion not found for diagnosis:', diagnosisName)
      }

      setPlanSuggestion(planSuggestion)

      const bimsScoreData = noteStructureRef?.current?.BIMSScore?.[diagnosisName]
      if (bimsScoreData && bimsScoreData.score) {
        const { date, score } = bimsScoreData
        const formattedDate = new Date(date).toLocaleDateString('en-US') // "4/23/2025"
        miscing += `\nBims Score: ${score} Date: ${formattedDate}`
      }

      const morseScoreData = noteStructureRef?.current?.MorseScore?.[diagnosisName]
      if (morseScoreData?.score) {
        const morseScores = morseScoreData.score
        const totalScore = Array.isArray(morseScores) ? morseScores[morseScores.length - 1] : morseScores
        const formattedDate = new Date(morseScoreData.date).toLocaleDateString('en-US')
        miscing += `\nMorse Score: ${totalScore} Date: ${formattedDate}`
      }
      // setMisc(miscing);
      setFreeType(freeType)
      setTempFreeType(freeType)

      // noteStructureRef.current = data   /// if something is not work plan then uncomment it, may be work
      let miscData = data && data.plans && noteStructureRef?.current?.plans[diagnosisName]?.labRemark + noteStructureRef?.current?.plans[diagnosisName]?.misc
      setLab(noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosisName] && noteStructureRef?.current?.plans[diagnosisName]?.labRemark)
      // setMisc(noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosisName] && noteStructureRef?.current?.plans[diagnosisName]?.misc)
      setAllData(noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosisName] && noteStructureRef?.current?.plans[diagnosisName]?.medsDetails)
      const formattedMedicationDetailsInFormattedRed =
        allData &&
        allData.length > 0 &&
        allData
          ?.map((item) => {
            // return `${item?.name} - <span>${item?.dosage}</span> - <span class="med-frequency" >${item?.frequency}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span></span>`;
            // return ` <span style="color: #000000d9;">${item?.editedMed}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.extraStandings}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.sideEffect}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.mechanismOfAction}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.alerts}</span> <br/> <span class="standing-template" style="color: #000000d9;">${item?.therapeuticLevels?.min} - ${item?.therapeuticLevels?.max}</span>`;
            return ` <span style="color: #000000d9;">${item?.editedMed}</span> <br/> `
          })
          .join('<br/><br/>')

      setPlanFormat(formattedMedicationDetailsInFormattedRed)

      handleMedicationAdd()
    } else {
      handleMedicationAdd()
    }
  }, [medicationList, masterMedications, diagnosisName, allLabs, patientTreatments, noteStructureRef])

  useEffect(() => {
    if (!diagnosisName) return
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...(noteStructureRef?.current?.plans?.[diagnosisName] || {}),
          medsDetails: allData,
        },
      },
    }
  }, [allData])

  const handleTemplateStatementCchnage = (e) => {
    setTemplateStatement(e.target.value)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans[diagnosisName],
          templateStatement: e.target.value,
        },
      },
    }
  }

  const handleMedicationChange = (e, index) => {
    const { value } = e.target
    const updatedMeds = [...allData]
    updatedMeds[index].editedMed = value
    setAllData(updatedMeds)
  }

  const handleStandingsChange = (e, index) => {
    const { value } = e.target
    const updatedMeds = [...allData]
    updatedMeds[index].extraStandings = value
    setAllData(updatedMeds)
  }

  // Freetype center
  const [tempFreeType, setTempFreeType] = useState('')
  const [visibleModalTempFreeType, setVisibleModalTempFreeType] = useState(false)
  const handleSaveFreetype = async () => {
    setVisibleModalTempFreeType(false)
    noteStructureRef.current = {
      ...noteStructureRef.current,
      plans: {
        ...noteStructureRef.current.plans,
        [diagnosisName]: {
          ...noteStructureRef.current.plans[diagnosisName],
          freeType: tempFreeType,
        },
      },
    }
    setFreeType(tempFreeType)
    await saveTreatsShell(false)
  }

  // Freetype center

  // useEffect(() => {
  //     noteStructureRef.current = {
  //         ...noteStructureRef.current,
  //         plans: {
  //             ...noteStructureRef.current.plans,
  //             [diagnosisName]: {
  //                 ...noteStructureRef.current.plans[diagnosisName],
  //                 misc: misc,
  //                 // labRemark: lab,
  //             }
  //         },
  //     };
  // }, [misc])

  return (
    <>
      {showTreatmentAsAccordion ? (
        <div>
          <div className="d-flex gap-2 align-items-center">
            <h7>
              <b>Plan</b>
            </h7>
          </div>
          <hr className="p-0 my-2 mb-3" />

          {!isTextInput ? (
            <div className="d-flex flex-column gap-3 px-2">
              <div className="d-flex flex-column gap-4 justify-content-center " style={{ position: '' }}>
                {/* Free Type */}
                {freeType && (
                  <div>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Free Type
                    </label>

                    <div
                      className="  mt-1"
                      style={{
                        overflowY: 'auto',
                        whiteSpace: 'pre-wrap',
                        fontSize: '1rem',
                      }}
                    >
                      {freeType}
                    </div>
                  </div>
                )}

                {/* Plan Suggestions */}
                {planSuggestion && (
                  <div>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Plan Suggestions
                    </label>

                    <div
                      className="  mt-1"
                      style={{
                        overflowY: 'auto',
                        whiteSpace: 'pre-wrap',
                        fontSize: '1rem',
                      }}
                    >
                      {planSuggestion}
                    </div>
                  </div>
                )}

                {/* Labs */}
                {lab && (
                  <div>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Labs
                    </label>

                    <div
                      className="  mt-1"
                      style={{
                        overflowY: 'auto',
                        whiteSpace: 'pre-wrap',
                        fontSize: '1rem',
                      }}
                    >
                      {lab}
                    </div>
                  </div>
                )}

                {/* Orders */}
                {orders?.length > 0 && (
                  <div>
                    <div className="d-flex gap-2 align-items-center">
                      <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                        New Orders
                      </label>
                    </div>
                    <div>
                      {orders?.length > 0 &&
                        orders
                          .filter((item) => item?.medication?.noteID === noteID)
                          .map((item, idx) => {
                            const currentOrder = item?.medication
                            return (
                              <div key={idx} className="mb-2">
                                {/* Imaging */}
                                {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Imaging:</strong>{' '}
                                    {currentOrder.imaging.imagingTypes
                                      .map((img) => img?.type)
                                      .filter(Boolean)
                                      .join(', ')}
                                  </p>
                                )}

                                {/* Labs */}
                                {currentOrder?.lab?.labs?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Labs:</strong>{' '}
                                    {currentOrder.lab.labs
                                      .map((labItem) => {
                                        const lab = labItem?.lab || ''
                                        const reason = labItem?.reason ? ` - Reason for ${lab}: ${labItem.reason}` : ''
                                        return `${lab}${reason}`
                                      })
                                      .join(', ')}
                                  </p>
                                )}

                                {/* Medications */}
                                {currentOrder?.medication?.medication?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Medications:</strong>{' '}
                                    {currentOrder.medication.medication
                                      .map((med) => {
                                        const details = [med?.name, med?.dosage, med?.route, med?.frequency].filter(Boolean).join(' ')
                                        return `${details}${med?.reason ? ` - ${med.reason}` : ''}`
                                      })
                                      .join(', ')}
                                  </p>
                                )}

                                {/* Miscellaneous */}
                                {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                  <p className="mb-1">
                                    <strong>Miscellaneous:</strong> {currentOrder.miscellaneous.miscellaneous.join(', ')}
                                  </p>
                                )}
                              </div>
                            )
                          })}
                    </div>
                  </div>
                )}

                {allData && allData.length > 0 && (
                  <div>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      ss
                    </label>

                    {allData &&
                      allData.length > 0 &&
                      allData?.map((item, idx) => {
                        return (
                          <div key={idx} className="  ">
                            {item?.editedMed && (
                              <div
                                className="  mt-2"
                                style={{
                                  overflowY: 'auto',
                                  whiteSpace: 'pre-wrap',
                                  fontSize: '0.9rem',
                                }}
                              >
                                {item?.editedMed}
                              </div>
                            )}

                            <div className="mt-3">
                              <p className="text-warning mb-1">
                                <strong>Side-effect:</strong>
                                <span className="text-warning"> {item.sideEffect}</span>
                              </p>
                              <p className="text-warning mb-1">
                                <strong>MOA:</strong>
                                <span className="text-warning"> {item.mechanismOfAction}</span>
                              </p>

                              {item.therapeuticLevels?.min && (
                                <p className="text-warning mb-1">
                                  <strong>Min-Max:</strong>
                                  <span className="text-warning">{`${item.therapeuticLevels?.min} - ${item.therapeuticLevels?.max}`}</span>
                                </p>
                              )}
                              <p className="text-warning mb-1">
                                <strong>Alert:</strong>
                                <span className="text-warning"> {item.alerts}</span>
                              </p>
                            </div>
                          </div>
                        )
                      })}
                  </div>
                )}

                {/* Template Statements */}
                {templateStatement && (
                  <div>
                    <label className="text-dark fw-semibold" style={{ fontSize: '14px' }}>
                      Template Statements
                    </label>

                    <div
                      className="  mt-1"
                      style={{
                        overflowY: 'auto',
                        whiteSpace: 'pre-wrap',
                        fontSize: '1rem',
                      }}
                    >
                      {templateStatement}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <>
              {allData && allData.length > 0 && (
                <div>
                  <div contentEditable={contentEditable} className="text-warning" dangerouslySetInnerHTML={{ __html: planFormat }} />
                  <div contentEditable={contentEditable} style={{ color: '#000000d9' }} dangerouslySetInnerHTML={{ __html: lab }} />
                  <div contentEditable={contentEditable} style={{ color: '#000000d9' }} dangerouslySetInnerHTML={{ __html: misc }} />
                </div>
              )}
            </>
          )}
        </div>
      ) : (
        <div>
          <div className="d-flex gap-2 align-items-center">
            <h7>
              <b>Plan</b>
            </h7>
            {/* {showTreatmentAsAccordion && <h7 style={{ fontSize: "14px" }}><b>Plan</b></h7>} */}
            {isAllotedToProvider && (
              <CFormLabel
                className="d-flex flex-column align-items-center mt-2 justify-content-center shadow "
                onClick={() => setOrderModalVisible((p) => !p)}
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '20px',
                  background: 'var(--ui-color-primary, #2b7cd3)',
                  cursor: 'pointer',
                }}
              >
                <Circle className="text-white" strokeWidth={2} size={15} />
              </CFormLabel>
            )}
          </div>
          <hr className="p-0 my-2 mb-3" />

          {!isTextInput ? (
            <div className="d-flex flex-column gap-3">
              <div className="d-flex flex-column gap-4 justify-content-center " style={{ position: '' }}>
                {/* <div style={{
                              position: 'absolute',
                              top: '10px',
                              left: '13px',
                              pointerEvents: 'none',
                              fontSize: '1rem',

                          }}
                          >
                              {lab}
                          </div> */}

                {/* Free Type */}
                <div  onClick={() => {
                      setTempFreeType(freeType)
                      setVisibleModalTempFreeType(true)
                    }}>
                  <CFormLabel>Free Type</CFormLabel>
                  <BulletTextArea
                    
                    onChange={() => {
                      return
                    }}
                    className="w-100"
                    height={'20px'}
                    // style={{
                    //     height: '180px',
                    //     paddingTop: `${lab ? (lab?.length + 5) - (lab?.length) : ''}ch`,
                    //     fontSize: '1rem'
                    // }}
                    value={freeType}
                  />
                </div>

                {/* Plan Suggestions */}
                <div>
                  <CFormLabel>Plan Suggestions</CFormLabel>
                  {noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosisName]?.planSuggestions && (
                      <div
                        className="p-2     my-2"
                        style={{
                          background: 'inherit',
                          borderRadius: '10px',
                          border: '1px solid gray',
                          color: 'inherit',
                          cursor: 'not-allowed',
                          pointerEvents: 'none', // disables click/interaction
                          userSelect: 'none', // optional: prevent text selection
                          opacity: 0.8,
                          whiteSpace: 'pre-wrap',      // preserve newlines
                          wordBreak: 'break-word',
                        }}
                        dangerouslySetInnerHTML={{
                          __html: noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosisName]?.planSuggestions
                        }}
                      ></div>
                  )}
                  <Graytextarea disabled height={'20px'} value={planSuggestion} />
                </div>

                {/* Labs */}
                <div>
                  <CFormLabel>Labs</CFormLabel>
                  <Graytextarea
                    className="w-100 "
                    // style={{
                    //     height: '180px',
                    //     paddingTop: `${lab ? (lab?.length + 5) - (lab?.length) : ''}ch`,
                    //     fontSize: '1rem'
                    // }}
                    height={'20px'}
                    disabled
                    value={lab}
                  />
                </div>

                {/* Orders */}
                <div>
                  <div className="d-flex gap-2 align-items-center">
                    <CFormLabel>New Orders</CFormLabel>
                  </div>
                  <div>
                    {orders?.length > 0 &&
                      orders
                        .filter((item) => item?.medication?.noteID === noteID)
                        .map((item, idx) => {
                          const currentOrder = item?.medication
                          return (
                            <div key={idx} className="mb-2">
                              {/* Imaging */}
                              {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                                <p className="mb-1">
                                  <strong>Imaging:</strong>{' '}
                                  {currentOrder.imaging.imagingTypes
                                    .map((img) => img?.type)
                                    .filter(Boolean)
                                    .join(', ')}
                                    {currentOrder.imaging.reason
                                    .map((img) => img?.reason)
                                    .filter(Boolean)
                                    .join(', ')}                                        
                                </p>
                              )}

                              {/* Labs */}
                              {currentOrder?.lab?.labs?.length > 0 && (
                                <p className="mb-1">
                                  <strong>Labs:</strong>{' '}
                                  {currentOrder.lab.labs
                                    .map((labItem) => {
                                      const lab = labItem?.lab || ''
                                      const reason = labItem?.reason ? ` - Reason for ${lab}: ${labItem.reason}` : ''
                                      
                                      return `${lab}${reason}`
                                    })
                                    .join(', ')}
                                </p>
                              )}

                              {/* Medications */}
                              {currentOrder?.medication?.medication?.length > 0 && (
                                <p className="mb-1">
                                  <strong>Medications:</strong>{' '}
                                  {currentOrder.medication.medication
                                    .map((med) => {
                                      const details = [med?.name, med?.dosage, med?.route, med?.frequency].filter(Boolean).join(' ')
                                      return `${details}${med?.reason ? ` - ${med.reason}` : ''}`
                                    })
                                    .join(', ')}
                                </p>
                              )}

                              {/* Miscellaneous */}
                              {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                                <p className="mb-1">
                                  <strong>Miscellaneous:</strong> {currentOrder.miscellaneous.miscellaneous.join(', ')}
                                </p>
                              )}
                            </div>
                          )
                        })}
                  </div>
                </div>

                <div>
                  <CFormLabel>Current Medications</CFormLabel>

                  {noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosisName]?.MedsDetails && (
                    <div className="my-2">
                      {/* <div
                        onClick={() => {
                          setTempMedHtmlContent(noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosisName]?.MedsDetails)
                          setShowMedHtml(true)
                        }}
                        className="p-4"
                        style={{ background: '#f6f6f6ff', borderRadius: '10px', cursor: 'text' }}
                        dangerouslySetInnerHTML={{ __html: noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosisName]?.MedsDetails }}
                      ></div> */}
                       <div
                            className="p-4"
                            style={{
                              background: 'inherit',
                              borderRadius: '10px',
                              border: '1px solid gray',
                              color: 'inherit',
                              cursor: 'not-allowed',
                              pointerEvents: 'none',
                              opacity: 0.8,
                            }}
                            dangerouslySetInnerHTML={{
                              __html: noteStructureRef?.current?.freeTypesEverything?.plans?.[diagnosisName]?.MedsDetails,
                            }}
                          ></div>
                    </div>
                  )}

                  {allData &&
                    allData.length > 0 &&
                    allData?.map((item, idx) => {
                      return (
                        <div key={idx} className="card mb-4 p-3 ">
                          <CFormInput
                            onChange={(e) => {
                              handleMedicationChange(e, idx)
                            }}
                            className="form-control my-2"
                            placeholder="Enter medication"
                            value={item.editedMed}
                          />
                          {/* <CFormInput
                                      onChange={(e) => { handleStandingsChange(e, idx) }}
                                      className="form-control my-2"
                                      placeholder="Enter standings"
                                      value={item.extraStandings}
                                  /> */}
                          <div className="mt-3">
                            <p className="text-warning mb-1">
                              <strong>Side-effect:</strong>
                              <span className="text-warning"> {item.sideEffect}</span>
                            </p>
                            <p className="text-warning mb-1">
                              <strong>MOA:</strong>
                              <span className="text-warning"> {item.mechanismOfAction}</span>
                            </p>

                            {item.therapeuticLevels?.min && (
                              <p className="text-warning mb-1">
                                <strong>Min-Max:</strong>
                                <span className="text-warning">{`${item.therapeuticLevels?.min} - ${item.therapeuticLevels?.max}`}</span>
                              </p>
                            )}
                            <p className="text-warning mb-1">
                              <strong>Alert:</strong>
                              <span className="text-warning"> {item.alerts}</span>
                            </p>
                          </div>
                        </div>
                      )
                    })}
                </div>

                {/* Template Statements */}
                <div>
                  <CFormLabel>Template Statements</CFormLabel>
                 {noteStructureRef?.current?.freeTypesEverything?.plans?.allTreatments?.[diagnosisName] && (
  <div className="my-2">
    <div
      className="p-2"
      style={{
        background: 'inherit',
        borderRadius: '10px',
        border: '1px solid gray',
        color: 'inherit',
        cursor: 'not-allowed',
        pointerEvents: 'none',
        opacity: 0.8,
        // userSelect: 'none' // keep or remove based on need
      }}
      dangerouslySetInnerHTML={{
        __html: noteStructureRef?.current?.freeTypesEverything?.plans?.allTreatments?.[diagnosisName]
      }}
    ></div>
  </div>
)}
                  <Graytextarea onChange={handleTemplateStatementCchnage} height={'20px'} value={templateStatement} />
                </div>
              </div>
            </div>
          ) : (
            <>
              {allData && allData.length > 0 && (
                <div>
                  <div contentEditable={contentEditable} className="text-warning" dangerouslySetInnerHTML={{ __html: planFormat }} />
                  <div contentEditable={contentEditable} style={{ color: '#000000d9' }} dangerouslySetInnerHTML={{ __html: lab }} />
                  <div contentEditable={contentEditable} style={{ color: '#000000d9' }} dangerouslySetInnerHTML={{ __html: misc }} />
                </div>
              )}
            </>
          )}
        </div>
      )}
      <CModal size="lg" backdrop="static" visible={orderModalVisible} onClose={() => setOrderModalVisible(false)} aria-labelledby="StaticBackdropExampleLabel">
        <AddOrders patientID={patientID} noteID={noteID} diagnosisName={diagnosisName} toggleModal={() => setOrderModalVisible((p) => !p)} fetchOrdersAgain={fetchOrders} />
      </CModal>

      {/* freetype modal */}
      <CModal backdrop="static" visible={visibleModalTempFreeType} onClose={() => setVisibleModalTempFreeType(false)} aria-labelledby="LiveDemoExampleLabel">
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Add Plan Freetype</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <BulletTextArea placeholder="Enter freetype" value={tempFreeType} rows={4} onChange={(e) => setTempFreeType(e.target.value)} />
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setVisibleModalTempFreeType(false)}>
            Close
          </CButton>
          <CButton color="primary" onClick={handleSaveFreetype}>
            Save changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showEditHtml} onClose={() => setShowEditHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Template Statement Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowEditHtml(false)}>
            Close
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  plans: {
                    ...noteStructureRef.current?.freeTypesEverything?.plans,
                    allTreatments: {
                      ...noteStructureRef.current?.freeTypesEverything?.plans?.allTreatments,
                      [diagnosisName]: tempHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowEditHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showMedHtml} onClose={() => setShowMedHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Morse Score Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempMedHtmlContent(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempMedHtmlContent}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowMedHtml(false)}>
            Close
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  plans: {
                    ...noteStructureRef.current?.freeTypesEverything?.plans,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.plans?.[diagnosisName],
                      MedsDetails: tempMedHtmlContent,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowMedHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>

      <CModal size="lg" visible={showPlanSuggestionHtml} onClose={() => setShowPlanSuggestionHtml(false)} aria-labelledby="OptionalSizesExample2">
        <CModalHeader>
          <CModalTitle id="OptionalSizesExample2">Edit Plan Suggestions Free Type</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Editor
            onChange={(e) => {
              setTempPlanSuggestionHtml(e.target.value)
            }}
            containerProps={{
              style: {
                width: '100%',
                background: '#f9f9f9',
                border: 0,
                height: '100%',
                minHeight: 'unset',
              },
            }}
            value={tempPlanSuggestionHtml}
          >
            <tooltip />
          </Editor>
        </CModalBody>
        <CModalFooter>
          <CButton variant="outline" color="secondary" onClick={() => setShowPlanSuggestionHtml(false)}>
            Close
          </CButton>
          <CButton
            color="primary"
            onClick={() => {
              noteStructureRef.current = {
                ...noteStructureRef.current,
                freeTypesEverything: {
                  ...noteStructureRef.current?.freeTypesEverything,
                  plans: {
                    ...noteStructureRef.current?.freeTypesEverything?.plans,
                    [diagnosisName]: {
                      ...noteStructureRef.current?.freeTypesEverything?.plans?.[diagnosisName],
                      planSuggestions: tempPlanSuggestionHtml,
                    },
                  },
                },
              }
              saveTreatsShell(false)
              setShowPlanSuggestionHtml(false)
            }}
          >
            Save Changes
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientTreatmentsPlans
